import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import FirebaseApp from './App';
import Admin from './Admin';
import Login from './Login';

// Main component to navigate between different app versions
// Both original App and FirebaseApp include full notepad functionality
const Main: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (password: string) => {
    // Simple authentication (you should use a more secure method in production)
    if (password === process.env.REACT_APP_ADMIN_PASSWORD || password === "admin123") {
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  return (
    <Router>
      <div className="app-wrapper">
        <Routes>
          <Route path="/" element={<FirebaseApp />} />
          <Route 
            path="/admin" 
            element={isAuthenticated ? <Admin onLogout={handleLogout} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/login" 
            element={<Login onLogin={handleLogin} isAuthenticated={isAuthenticated} />} 
          />
        </Routes>
        
        {/* Navigation Menu */}
        {/* <div className="nav-menu">
          <Link to="/" className="nav-item">lofizone</Link>
          <Link to={isAuthenticated ? "/admin" : "/login"} className="nav-item">Admin Panel</Link>
        </div> */}
      </div>
      
      <style>{`
        .app-wrapper {
          width: 100%;
          height: 100vh;
          position: relative;
        }
        
        .nav-menu {
          position: fixed;
          top: 10px;
          left: 50%;
          transform: translateX(-50%);
          background-color: rgba(0, 0, 0, 0.5);
          border-radius: 20px;
          padding: 5px 15px;
          z-index: 1000;
          display: flex;
          gap: 20px;
        }
        
        .nav-item {
          color: white;
          text-decoration: none;
          padding: 5px 10px;
          font-size: 14px;
          border-radius: 15px;
          transition: background-color 0.3s;
        }
        
        .nav-item:hover {
          background-color: rgba(255, 255, 255, 0.2);
        }
      `}</style>
    </Router>
  );
};

export default Main; 